/**
 * Importação da classe genérica para requisições em serviços
 */
import GenericCrud from './GenericCrud';

import privateNetwork from '@adm/services/networkRequest';
/**
 * Importação da biblioteca axios para fazer requisições baseadas em Promises.
 */
import axios from 'axios';

const localRequest = axios.create();
localRequest.interceptors.response.use(function (response) {
  const data = response.data;
  delete data._links;
  return data;
});

class Settings extends GenericCrud {
  constructor(
    endpoint = 'configuracao',
    authorization = {
      get: 'public',
      post: 'private',
      put: 'private',
      delete: 'private',
    },
    apiVersion
  ) {
    super(endpoint, authorization, apiVersion);
  }

  async get(id) {
    return localRequest(
      `${process.env.REACT_APP_API_HOST}${this.apiVersion}${this.endPoint}/${id}`
    );
  }

  async getByKey(key) {
    return localRequest(
      `${process.env.REACT_APP_API_HOST}${this.apiVersion}${this.endPoint}?chave=${key}`
    );
  }

  async put(body) {
    return privateNetwork.put(`${process.env.REACT_APP_API_HOST}${this.apiVersion}${this.endPoint}/${body.id}`, body);
  }
}

// Exportando uma instância de configurações
export default new Settings();
